import { defineMessages } from 'react-intl.macro';

import { useMessage } from '@tmapy/intl';

import { AttachmentTypeEnum } from '../../openapi/types/AttachmentTypeEnum';

export const errorTypeMessages = defineMessages({
  UNKNOWN_ERROR: {
    id: 'document.error.type.UNKNOWN_ERROR',
    defaultMessage: 'Neznámá chyba',
  },
  METHOD_NOT_ALLOWED: {
    id: 'document.error.type.METHOD_NOT_ALLOWED',
    defaultMessage: 'Metoda není povolena',
  },
  UNAUTHORIZED: {
    id: 'document.error.type.UNAUTHORIZED',
    defaultMessage: 'Neautorizovaný přístup',
  },
});

export const errorFileMessages = defineMessages<AttachmentTypeEnum>({
  [AttachmentTypeEnum.OTHER]: {
    id: 'document.error.check.OTHER',
    defaultMessage: 'Je potřeba přidat soubor s ostatními daty',
  },
  [AttachmentTypeEnum.UPDATE_DATA]: {
    id: 'document.error.check.UPDATE_DATA',
    defaultMessage: 'Je potřeba přidat soubor s aktualizačními daty',
  },
  [AttachmentTypeEnum.REFERENCE_DATA]: {
    id: 'document.error.check.REFERENCE_DATA',
    defaultMessage: 'Je potřeba přidat soubor s referenčními daty',
  },
  [AttachmentTypeEnum.UPDATE_DATA_RANGE]: {
    id: 'document.error.check.UPDATE_DATA_RANGE',
    defaultMessage: 'Je potřeba přidat soubor s aktualizačním rozsahem dat',
  },
  [AttachmentTypeEnum.DERIVED_DATA_RANGE]: {
    id: 'document.error.check.DERIVED_DATA_RANGE',
    defaultMessage: 'Je potřeba přidat soubor s odvozeným rozsahem dat',
  },
  [AttachmentTypeEnum.METADATA]: {
    id: 'document.error.check.METADATA',
    defaultMessage: 'Je potřeba přidat soubor s metadaty',
  },
  [AttachmentTypeEnum.ROZSAH_EDITACE]: {
    id: 'document.error.check.ROZSAH_EDITACE',
    defaultMessage: 'Je potřeba přidat soubor s rozsahem editace',
  },
  [AttachmentTypeEnum.SYNCHRONIZACNI_DATA_SOUSEDNIHO_KRAJE]: {
    id: 'document.error.check.SYNCHRONIZACNI_DATA_SOUSEDNIHO_KRAJE',
    defaultMessage: 'Je potřeba přidat soubor se synchronizačními daty sousedního kraje',
  },
  [AttachmentTypeEnum.ZAPRACOVANA_DATA_PRESHRANICNI_EDITACE]: {
    id: 'document.error.check.ZAPRACOVANA_DATA_PRESHRANICNI_EDITACE',
    defaultMessage: 'Je potřeba přidat soubor se zapracovanými daty přeshraniční editace',
  },
  [AttachmentTypeEnum.DVOJICE_IDENTIFIKATORU]: {
    id: 'document.error.check.DVOJICE_IDENTIFIKATORU',
    defaultMessage: 'Je potřeba přidat soubor s dvojicí identifikátorů',
  },
});

export const getErrorMessages = (
  data?: { message: string; code: string }[] | Record<string, { message: string; code: string }[]>,
): { code: string; message: string }[] | null => {
  if (data) {
    if (Array.isArray(data)) {
      return data;
    } else if (typeof data === 'object') {
      const result: { code: string; message: string }[] = [];
      Object.keys(data).forEach((key) => {
        if (Array.isArray(data[key])) {
          data[key].forEach((item: { message: string; code: string }) => {
            result.push({
              ...item,
              code: key,
            });
          });
        }
      });
      return result.length ? result : null;
    }
    return null;
  }
  return null;
};

export type ResponseErrorMessageContainerProps = {
  error: { code: string; message: string } | null;
};

export const ResponseErrorMessage: React.FC<ResponseErrorMessageContainerProps> = ({ error }) => {
  if (!error) {
    return null;
  }

  const formatMessage = useMessage();

  switch (error.code) {
    case 'method_not_allowed':
      return formatMessage(errorTypeMessages.METHOD_NOT_ALLOWED);
    case 'unauthorized':
      return formatMessage(errorTypeMessages.UNAUTHORIZED);
    case 'non_field_errors':
      return error.message;
    default: // invalid
      const specificError = Object.values(AttachmentTypeEnum).find((attachmentError) =>
        error.message.includes(attachmentError),
      );
      return specificError
        ? formatMessage(errorFileMessages[specificError])
        : formatMessage(errorTypeMessages.UNKNOWN_ERROR);
  }
};
